module.exports = __webpack_public_path__ + "img/40_00_000_805.0ac923ba.jpg";